import { sortByKey } from '@robovision/rvai-utils'
import { Extensions } from '~domain/Extensions'


/**
 * Browser-safe replacement for `path.basename`.
 */
function basename (filename: string, ext?: string): string {
  const base = filename.slice(filename.lastIndexOf('/') + 1)

  if (ext && base !== ext && base.endsWith(ext)) {
    return base.slice(0, base.length - ext.length)
  }

  return base
}

/**
 * Browser-safe replacement for `path.extname`.
 *
 * Returns the extension of the given path (including the leading dot), or an
 * empty string when there is none.
 */
export function extractExtension (filename: string): string {
  const base = basename(filename)
  const dotIndex = base.lastIndexOf('.')

  return dotIndex <= 0 ? '' : base.slice(dotIndex)
}

export function extractBasename (filename: string): string {
  // Get the longest matching "known" extension
  const ext = sortByKey(Object.values(Extensions), 'length', false)
    .find((e) => filename.endsWith(e))

  return basename(filename, ext)
}
